<template>
  <!-- 텍스트 배너 -->
  <div
    v-if="textBanner.length > 0"
    class="text-banner"
  >
    <ul>
      <li
        v-for="banner in textBanner"
        :key="banner.id"
      >
        <a
          v-if="banner.contentType === 1"
          @click="handleDrugInfoClick(banner.contentId)"
        >
          <span class="info-type banner-item">약품정보</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 2"
          @click="handleMedicalTrendClick(banner.contentId)"
        >
          <span class="trend-type banner-item">메디컬 트렌드</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 3"
          @click="handleSurveyClick(banner.contentId)"
        >
          <span class="survey-type banner-item">설문조사</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 5"
          @click="handleWebseminarClick(banner.contentId)"
        >
          <span class="seminar-type banner-item">웹세미나</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 6"
          @click="handleNoticeClick(banner.contentId)"
        >
          <span class="notice-type banner-item">공지사항</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 7"
          @click="handleEventClick(banner.contentId)"
        >
          <span class="event-type banner-item">이벤트</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 8"
          @click.prevent="callDrugLanding(banner.contentId)"
        >
          <span class="medical-type banner-item">간편처방 등록</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { callExternalApi } from '@/core/global/global-liveinfo'
import { SNT } from '@/core/global/global-enums'

export default {
  components: {
  },
  data() {
    return {
      textBanner: []
    }
  },
  computed: {
    ...mapGetters({
      medicalDept: 'infoData/getMedicalDept',
      region: 'infoData/getRegion',
      shaEnLicenseNum: 'infoData/getShaEnLicenseNum',
      banners: 'infoData/getBanners',
    })
  },
  mounted() {
    this.getTextBanners()
  },
  methods: {
    getTextBanners() {
      this.textBanner = this.banners.filter(x => x.bannerLocation === 11)
      if (this.textBanner.length >= 2) {
        const shuffled = [...this.textBanner].sort(() => Math.random() - 0.5)
        this.textBanner = shuffled.slice(0, 2)
      }
    },
    handleDrugInfoClick(contentId) {
      this.$emit('open-drug-info', contentId, SNT.A.Service_컨텐츠__약품정보, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleMedicalTrendClick(contentId) {
      this.$emit('open-medical-trend', contentId, SNT.A.Service_컨텐츠__메디컬트렌드, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleSurveyClick(contentId) {
      this.$emit('open-survey', contentId, SNT.A.Service_컨텐츠__설문조사, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleWebseminarClick(contentId) {
      this.$emit('open-webseminar', contentId, 1, SNT.A.Service_컨텐츠__웹세미나, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleNoticeClick(contentId) {
      this.$emit('open-notice', contentId, SNT.A.Service_컨텐츠__공지사항, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleEventClick(contentId) {
      this.$emit('open-event', contentId, SNT.A.Service_컨텐츠__이벤트, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    callDrugLanding(contentId) {
      callExternalApi("CallLandingPopup", String(contentId))
    }
  }
}
</script>
